import clsx from "clsx";
import "./appLoadingText.css";
import { memo } from "react";

type AppLoadingTextProps = {
	readonly children: string;
	readonly className?: string;
};

function AppLoadingText({ children, className }: AppLoadingTextProps) {
	return (
		<span className={clsx("inline-flex items-center gap-1.5", className)}>
			<span className="animate-app-assistente-thinking-shine bg-[linear-gradient(110deg,var(--mui-palette-secondary-main)_0%,var(--mui-palette-secondary-main)_35%,var(--mui-palette-primary-main)_48%,var(--mui-palette-secondary-main)_62%,var(--mui-palette-secondary-main)_100%)] bg-[length:240%_100%] bg-clip-text text-transparent">
				{children}
			</span>
		</span>
	);
}

export default memo(AppLoadingText);
